import { useEffect, useRef } from 'react'

// A cog button added as a native MapLibre control, so it stacks in the top-right
// column right under the fullscreen button. Clicking it opens the display-
// settings panel (borders / palette / world overlays).
class SettingsControl {
  constructor(onOpen) { this._onOpen = onOpen }
  onAdd() {
    const div = document.createElement('div')
    div.className = 'maplibregl-ctrl maplibregl-ctrl-group pr-settings-ctrl'
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.title = 'Réglages d\'affichage'
    btn.setAttribute('aria-label', 'Réglages d\'affichage')
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>'
    btn.addEventListener('click', () => this._onOpen())
    div.appendChild(btn)
    this._div = div
    return div
  }
  onRemove() { this._div?.parentNode?.removeChild(this._div) }
}

export function useSettingsControl(map, onOpen) {
  const onOpenRef = useRef(onOpen)
  onOpenRef.current = onOpen
  useEffect(() => {
    if (!map.current) return
    const ctrl = new SettingsControl(() => onOpenRef.current?.())
    map.current.addControl(ctrl, 'top-right')
    return () => { try { map.current?.removeControl(ctrl) } catch { /* map gone */ } }
  }, [map])
}
